import React from 'react';

export default function NotFoundRoute() {
  return (
    <div className='ui text container'>
      <h1 className='ui header p-t-lg'>404 Not Found</h1>
    </div>
  );
}
